import { ArrowRight } from "lucide-react";
import type { ReactNode } from "react";

type Tone = "dark" | "blue" | "light";

const tones: Record<Tone, { shell: string; knob: string; icon: string }> = {
  dark: {
    shell: "bg-nodric-ink text-white hover:bg-black",
    knob: "bg-white",
    icon: "text-nodric-ink",
  },
  blue: {
    shell: "bg-nodric-blue text-white hover:bg-nodric-blue-deep",
    knob: "bg-white",
    icon: "text-nodric-blue",
  },
  light: {
    shell: "bg-white text-nodric-ink hover:bg-white/90",
    knob: "bg-nodric-ink",
    icon: "text-white",
  },
};

/** Pill CTA of the landing: label on the left, circular arrow knob on the right. */
export default function PillButton({
  children,
  onClick,
  tone = "dark",
  withArrow = true,
  submit = false,
  className = "",
}: {
  children: ReactNode;
  onClick?: () => void;
  tone?: Tone;
  withArrow?: boolean;
  submit?: boolean;
  className?: string;
}) {
  const t = tones[tone];

  return (
    <button
      type={submit ? "submit" : "button"}
      onClick={onClick}
      className={`group font-display inline-flex cursor-pointer items-center gap-8 rounded-full py-1.5 pr-1.5 pl-6 text-[11px] font-medium tracking-[0.18em] uppercase transition-all duration-300 hover:scale-[1.02] active:scale-[0.98] ${t.shell} ${withArrow ? "" : "pr-6"} ${className}`}
    >
      <span className="whitespace-nowrap">{children}</span>
      {withArrow && (
        <span
          className={`flex h-8 w-11 items-center justify-center rounded-full transition-transform duration-300 group-hover:translate-x-0.5 ${t.knob}`}
        >
          <ArrowRight className={`h-4 w-4 ${t.icon}`} strokeWidth={2} />
        </span>
      )}
    </button>
  );
}
